import {
  RESTORE_AUTHENTICATION,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  INCREMENT_REFERRAL,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAILURE,
  ACCEPT_TERMS_AND_CONDITIONS_SUCCESS,
  ACCEPT_TERMS_AND_CONDITIONS_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_FAILURE,
  SIGN_OUT,
} from "features/application/authentication/redux/types";

const authenticationReducer = (
  state = { responseCodes: {}, errorCodes: {} },
  action
) => {
  switch (action.type) {
    case RESTORE_AUTHENTICATION:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        token: {
          access: action.payload.access,
          refresh: action.payload.refresh,
          expiresIn: action.payload.expiresIn,
        },
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        token: {
          access: action.payload.access_token,
          refresh: action.payload.refresh_token,
          expiresIn: action.payload.expires_in,
        },
      };
    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { refreshToken: action.payload },
      };
    case INCREMENT_REFERRAL:
      return { ...state };
    case SIGN_UP_SUCCESS:
      fbq("track", "Contact"); // eslint-disable-line
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        token: {
          access: action.payload.access_token,
          refresh: action.payload.refresh_token,
          expiresIn: action.payload.expires_in,
        },
      };
    case SIGN_UP_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { signUp: action.payload },
      };
    case CONFIRM_EMAIL_SUCCESS:
      return {
        ...state,
        responseCodes: { confirmEmail: action.payload },
        errorCodes: {},
      };
    case CONFIRM_EMAIL_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { confirmEmail: action.payload },
      };
    case ACCEPT_TERMS_AND_CONDITIONS_SUCCESS:
      fbq("track", "SubmitApplication"); // eslint-disable-line
      return { ...state, responseCodes: {}, errorCodes: {} };
    case ACCEPT_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { termsAndConditions: action.payload },
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        responseCodes: {},
        errorCodes: {},
        token: {
          access: action.payload.access_token,
          refresh: action.payload.refresh_token,
          expiresIn: action.payload.expires_in,
        },
      };
    case SIGN_IN_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { signIn: action.payload },
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        responseCodes: { resetPassword: action.payload },
        errorCodes: {},
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { resetPassword: action.payload },
      };
    case CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        responseCodes: { createPassword: action.payload },
        errorCodes: {},
      };
    case CREATE_PASSWORD_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { createPassword: action.payload },
      };
    case CHANGE_EMAIL_SUCCESS:
      return {
        ...state,
        responseCodes: { changeEmail: action.payload },
        errorCodes: {},
      };
    case CHANGE_EMAIL_FAILURE:
      return {
        ...state,
        responseCodes: {},
        errorCodes: { changeEmail: action.payload },
      };
    case SIGN_OUT:
      return {
        responseCodes: { ...state.responseCodes },
        errorCodes: { ...state.errorCodes },
      };
    default:
      return state;
  }
};

export default authenticationReducer;
